export const styles = {
  container:{
    maxWidth: "1280px",
  },
  paper: {
    padding: "0",
    boxShadow: "none",
    marginTop:"0",
    marginBottom: "0",
    background: "transparent"
  },
  paperResult: {
    border:"1px solid rgb(0 0 0/ 8%)",
    padding: "2% 3%",
    boxShadow: "2px 6px 6px -2px rgb(51 84 255 / 20%)",
    margin: "0",
    borderRadius: "8px",
    marginBottom: "20px"
  }, 
  paperCategory: {
    padding: "1%",
    boxShadow: "none",
    borderBottom: "1px solid #e0e0e0",
    "&:last-of-type":{
      border: "none !important",
    }
  },     
  mainTitle: {
    fontFamily: "Montserrat",
    fontWeight: "400",
    fontSize: "44px",
    lineHeight: "40px",
    padding: "4px 0",
    margin: "20px 0",
    color: "#3354FF",
  },
  subTitleResult: {
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "500",
    padding: "12px 0px",
    lineHeight: "26px",
    letterSpacing: "normal",
  },  
  subTitle: {
    borderLeft: "12px solid #3354FF",
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "400",
    padding: "6px 12px",
    background: "rgb(51 84 255/ 15%)",
    lineHeight: "26px",
    letterSpacing: "normal",
  },
  subTitleHome: {
    borderLeft: "12px solid #3354FF",
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "400",
    padding: "6px 12px",
    background: "rgb(51 84 255/ 15%)",
    lineHeight: "26px",
    letterSpacing: "normal",
    margin: "20px 0px"
  },  
  subTitledescription:{
    fontSize: "16px",
    fontHeight: "1.3rem",
    fontFamily: "'Roboto', sans-serif !important",
    marginBottom: "16px",
  }, 
  buttonContainer: {
    display:"flex",
    justifyContent: "space-between",
    marginTop: "20px",
    alignItems: "center"
  },
  submitButton: {
    margin: "0",
    padding: "10px 30px",
    borderRadius: "50px",
    background: "#B07520",
    widtH: "auto",
    color: "white",
    textTransform:"capitalize",
    fontSize: "18px",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#cf8826",
    },
  },
  submitButtonDisabled: {
    margin: "0",
    padding: "10px 30px",
    borderRadius: "50px",
    background: "grey",
    widtH: "auto",
    color: "white !important",
    textTransform:"capitalize",
    fontSize: "18px",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "grey",
    },
  },  
  question: {
    fontSize: "16px",
    marginBottom: "8px",
    fontWeight: "500",
    letterSpacing: "0",
    lineHeight: "inherit",
  },
  category_wrapper:{
    margin:"0",
    marginBottom:"30px",
    borderRadius: "8px",
    border: "1px solid rgb(0 0 0 / 8%)",
    boxShadow: "2px 6px 6px -2px rgb(51 84 255 / 20%)",
    padding: "2% 3%",
     background: "white"
  },
  topic_wrapper:{
    marginBottom:"30px",
    // background: "white",
  },  
  category: {
    fontSize: "20px",
    marginBottom: "10px",
    fontWeight: "600",
    borderBottom: "none",
    lineHeight: "28px",
    color: "#000",
  },  
  answer: {
    fontSize: "16px",
    marginBottom: "5px",
    fontWeight: "500",
    lineHeight: "10px",
    marginLeft: "10px",
    display: "flex",
    color: "#2C58FF",
  },
  correctAnswer: {
    color: "#2C58FF !important",
    '&:checked': {
      color: ".5rem",
    },
  },
  results: {
    display: "flex",
    fontSize:"18px",
    margin: "0 auto",
    textAlign: "left",
    flexDirection: "column",
  },
  resultsTitle:{
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "400",
    padding: "6px 12px",
    lineHeight: "26px",
    letterSpacing: "normal",
    margin:"0",
    borderLeft: "12px solid #3354FF",
    background: "rgb(51 84 255/ 15%)",    
  },
  resultssubTitledescription:{
    fontSize: "16px",
    lineHeight: "1.3rem",
    fontFamily: "'Roboto', sans-serif !important",
  },
  resultsFeedback:{
    lineHeight: "3rem",
    fontFamily: "'Roboto', sans-serif !important",
  },
  resultsFeedbackHighlighted:{
    background: "#e0e0e0",
    fontWeight: "700",
    lineHeight: "1.5rem",
    marginRight: "6px",
    borderRadius: "4px",
    padding: "4px 8px",
  },
  resultsFeedbackDescription:{
    fontSize: "16px",
    lineHeight: "1.5rem",
    fontFamily: "'Roboto', sans-serif !important",
  },
  listTopics:{
      listStyle: "none",   
  },
  imagePortada:{
    width: "450px"
    // display: "none"
  },
  imagePoweredby:{
    width: "150px"
    // display: "none"
  },
  homeSubcontainer:{
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 767px)": {
      flexDirection: 'column',
    }
  },
  selectItem:{
    listStyleType: "none",
    "&li:before":{
      content: ''
    }
  },
  emailError:{
    color:"red"
  },
  languageSelectorContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  flagIcon: {
    cursor: "pointer"
  }

};

export const createMarkup = (text) => {
  return { __html: text };
};
